import React from "react";
class BankVerificationAlert extends React.Component {
    render() {
        return (
            <div>

                <div className="fixed absolute--fill bg-black-60 relative z-999 ph3  pv4 flex justify-center items-center">
                    <div className="w8 ph2 pb2 bg-white tc f6 flex flex-column">
                        <p className="gray f6">your bank is beign verified.</p>
                        <p className="gray f6 ph4">It usally takes 5-10 days we will inform once done via SMS or Email.</p>
                        <button className="mv0 w3 h2 f6 center mt2 tc bg-green white ">LINK</button></div>
                </div>

            </div>


        )
    }
}
export default BankVerificationAlert;